@file:Suppress("DEPRECATION")

package devxertech.com.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaPlus
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint.LG
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.models.MenuModel
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Constants.FONT_FAMILY
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul
import org.w3c.dom.Element
import org.w3c.dom.events.EventListener


@Composable
fun MenuDropdown(
    data: List<MenuModel>,
    title: String? = null,
    textSpanColor: Color? = null,
    icon: (@Composable () -> Unit)? = null,
    onSelect: (String) -> Unit,
) {
    val sitePalette = ColorMode.current.toSitePalette()
    val resolvedTextColor = textSpanColor ?: sitePalette.topBarMenuText.rgb
    val breakpoint = rememberBreakpoint()
    val isHoverEnabled = title == "Services +" || title == "Industries +"
    var hoveredIndex by remember { mutableStateOf<Int?>(null) }

    val safeTitle = title?.replace(" ", "")?.replace("+", "") ?: "Dropdown"
    var isDropdownOpen by remember { mutableStateOf(false) }
    var isTitleHovered by remember { mutableStateOf(false) }
    var isDropdownHovered by remember { mutableStateOf(false) }
    var timeoutHandle: Int? = remember { null }
    var showSpinner by remember { mutableStateOf(false) }
    var spinTriggered by remember { mutableStateOf(false) }

    LaunchedEffect(isTitleHovered) {
        if (isTitleHovered && !spinTriggered) {
            spinTriggered = true
            showSpinner = true
            delay(1000)
            showSpinner = false
        }
        if (!isTitleHovered) {
            spinTriggered = false // reset when mouse leaves
        }
    }

    DisposableEffect(isDropdownOpen) {
        if (!isHoverEnabled) return@DisposableEffect onDispose {}
        val listener = EventListener { event ->
            val target = event.target as? Element
            val dropdown = document.getElementById("leaderboardDropDown-$safeTitle")
            val trigger = document.getElementById("menuDropDown-$safeTitle")
            if (isDropdownOpen && target != null && dropdown != null && trigger != null &&
                !dropdown.contains(target) && !trigger.contains(target)
            ) {
                isDropdownOpen = false
            }
        }
        window.addEventListener("click", listener)
        onDispose { window.removeEventListener("click", listener) }
    }

    Box(
        modifier = Modifier
            .id("menuDropDown-$safeTitle")
            .cursor(Cursor.Pointer)
            .position(Position.Relative)
    ) {
        // Title Hover Area
        Box(
            modifier = Modifier
                .onClick {
                if (isTitleHovered) isDropdownOpen = !isDropdownOpen }
            .onMouseEnter {
                    isTitleHovered = true
                    isDropdownOpen = true
                    timeoutHandle?.let { window.clearTimeout(it) }
                }
                .onMouseLeave {
                    isTitleHovered = false
                    timeoutHandle = window.setTimeout({
                        if (!isDropdownHovered) {
                            isDropdownOpen = false
                        }
                    }, 300)
                }
        ) {
            icon?.let {
                it()
                CustomSpacer(width = 10.px)
            }
            Column(
                modifier = Modifier.alignItems(AlignItems.Center)
                    .onMouseEnter {
                    isTitleHovered = true
                    showSpinner = true }
            ) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(6.px) // spacing between icon and text
                ) {
                    FieldTitleTextNormalSimple(
                        text = title ?: "",
                        color = resolvedTextColor,
                        onClick = {},
                        fontWeight = 500,
                        textTransform = TextTransform.Uppercase,
                        isClickable = true,
                        fontSize = if (breakpoint == LG || window.screen.width in 1440..1650) 15.px else 18.px,
                        fontFamily = Constants.Top_Menu_Family
                    )
                    FaPlus(
                        modifier = Modifier
                            .color(sitePalette.topBarMenuText.rgb)
                            .fontSize(13.px)
                            .transition(Transition.of(TransitionProperty.All, 300.ms))
                            .transform {
                                if (isTitleHovered) {
                                    rotate(180.deg)
                                } else {
                                    rotate(0.deg) }
                            })
                }
                Box(
                    modifier = Modifier
                        .height(3.px)
                        .width(if (isTitleHovered) 20.px else 0.px)
                        .backgroundColor(resolvedTextColor)
                        .transition(Transition.of(TransitionProperty.All, 300.ms))
                )
            }
        }
        Box(
            modifier = Modifier
                .position(Position.Absolute)
                .top(30.px)
                .zIndex(999)
                .onMouseEnter {
                    isDropdownHovered = true
                    timeoutHandle?.let { window.clearTimeout(it) }
                }
                .onMouseLeave {
                    isDropdownHovered = false
                    isDropdownOpen = false
                })
        // Dropdown Content
        if (isDropdownOpen) {
            Box(modifier = Modifier.zIndex(999)) {
                Ul(
                    attrs = Modifier
                        .width(250.px)
                        .maxWidth(250.px)
                        .id("leaderboardDropDown-$safeTitle")
                        .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                        .padding(topBottom = 0.px)
                        .borderRadius(5.px)
                        .position(Position.Absolute)
                        .classNames("custom-ul-clean")
                        .top(30.px) // 26px + 28px bridge
                        .zIndex(98)
                        .onMouseEnter {
                            isDropdownHovered = true
                            timeoutHandle?.let { window.clearTimeout(it) }
                        }
                        .onMouseLeave {
                            isDropdownHovered = false
                            isDropdownOpen = false
                        }
                        .toAttrs()
                ) {
                    data.forEachIndexed { index, item ->
                        val isFirst = index == 0
                        val isLast = index == data.lastIndex

                        Li {
                            menuItem(
                                text = item.text,
                                isFirst = isFirst,
                                isLast = isLast,
                                modifier = Modifier,
                                isHovered = hoveredIndex == index,
                                onHover = { hoveredIndex = index },
                                onLeave = { hoveredIndex = null }
                            ) {
                                hoveredIndex = null
                                isDropdownOpen = false
                                onSelect(item.text)
                            }
                        }
                    }

                }
            }
        }
    }
}

@Composable
fun menuItem(
    modifier: Modifier,
    text: String,
    isFirst: Boolean = false,
    isLast: Boolean = false,
    isHovered: Boolean,
    onHover: () -> Unit,
    onLeave: () -> Unit,
    onSelect: (String) -> Unit,

) {
    val sitePalette = ColorMode.current.toSitePalette()
    A(
        attrs = modifier
            .margin(topBottom = 0.px)
            .classNames("dropdown-item")
            .fontFamily(FONT_FAMILY)
            .fontSize(16.px)
            .padding(leftRight = 10.px, topBottom = 10.px)
            .borderRadius(
                topLeft = if (isHovered && isFirst) 5.px else 0.px,
                topRight = if (isHovered && isFirst) 5.px else 0.px,
                bottomLeft = if (isHovered && isLast) 5.px else 0.px,
                bottomRight = if (isHovered && isLast) 5.px else 0.px,
            )
            .backgroundColor(if (isHovered) sitePalette.primary.rgb else Colors.Transparent)
            .onMouseEnter { onHover() }
            .onMouseLeave { onLeave() }
            .onClick { onSelect(text) }
            .toAttrs()
    ) {

        SpanText(
            text = text,
            modifier = Modifier
                .fillMaxWidth()
                .display(DisplayStyle.InlineBlock)
                .transition(
                    Transition.of(
                        "transform",
                        200.ms,
                    )
                )
                .transform { if (isHovered) translateX(8.px) else translateX(0.px) }
                .color(if (isHovered) sitePalette.modalBackgroundColor.rgb else sitePalette.textFieldTextColor.rgb)
                .fontSize(15.px)
                .fontWeight(500)
                .fontFamily(FONT_FAMILY)
        )
    }
}

@Composable
fun DropdownItem(text: String, onClick: () -> Unit) {
    var isHovered by remember { mutableStateOf(false) }
    var sideBarText by remember { mutableStateOf(false) }
    val sitePalette = ColorMode.current.toSitePalette()
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(8.px)
            .backgroundColor(if (isHovered) sitePalette.primary.rgb else Colors.Transparent)
            .cursor(Cursor.Pointer)
            .onMouseEnter { isHovered = true }
            .onMouseLeave { isHovered = false }
            .onClick {
                onClick()
            }
    ) {
        FieldTitleTextNormalSimple(
            text = text,
            color = if (isHovered) sitePalette.modalBackgroundColor.rgb else if (sideBarText) sitePalette.sideBarDropDown.rgb else
                sitePalette.commonSecondaryButtonColor.rgb,
            fontSize = 16.px,
            onClick = onClick,
            isClickable = true,
            onMouseEnter = { isHovered = true },
            onMouseLeave = { isHovered = false }
        )
    }
}